import { Filters, OrganizationUser } from "toptaal-shared"

export const organizationQueryKeys = {
  all: ["organizations"] as const,
  style: () => [...organizationQueryKeys.all, "style"] as const,
  me: () => [...organizationQueryKeys.all, "me"] as const,
  filters: (filters: Filters) =>
    [...organizationQueryKeys.all, "filters", filters] as const,
  detail: () => [...organizationQueryKeys.all, "detail"] as const,
  companyPicture: () =>
    [...organizationQueryKeys.all, "companyPicture"] as const,
}

export const organizationUserQueryKeys = {
  all: ["organization_users"] as const,
  me: () => [...organizationUserQueryKeys.all, "me"] as const,
  user: (organizationUserId: OrganizationUser["id"]) =>
    [...organizationUserQueryKeys.all, "user", organizationUserId] as const,
  students: (organizationUserId: OrganizationUser["id"]) =>
    [...organizationUserQueryKeys.all, "students", organizationUserId] as const,
  users: (filters?: Filters) =>
    [...organizationUserQueryKeys.all, "users", filters] as const,
  filters: (filters?: Filters) =>
    [...organizationUserQueryKeys.all, "filters", filters] as const,
}
